import React from 'react';

const SmartContractContext = React.createContext(null);

export default SmartContractContext;